import {Component} from '@angular/core';
/**
 * \@title Configurable progress spinner
 */
export class ProgressSpinnerConfigurableExample {
  color = 'primary';
  mode = 'determinate';
  value = 50;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'progress-spinner-configurable-example',
  templateUrl: 'progress-spinner-configurable-example.html',
  styleUrls: ['progress-spinner-configurable-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProgressSpinnerConfigurableExample_tsickle_Closure_declarations() {
/** @type {?} */
ProgressSpinnerConfigurableExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressSpinnerConfigurableExample.ctorParameters;
/** @type {?} */
ProgressSpinnerConfigurableExample.prototype.color;
/** @type {?} */
ProgressSpinnerConfigurableExample.prototype.mode;
/** @type {?} */
ProgressSpinnerConfigurableExample.prototype.value;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
